module.exports = "/_next/static/images/40eab063b21ddd510b4697855c928ac5-sequoia.png";